import type { InputBaseComponentProps } from '@mui/material';

import React from 'react';
import { PatternFormat } from 'react-number-format';

type PhoneNumberFormatProps = Omit<InputBaseComponentProps, 'defaultValue'> & {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  defaultValue?: string | number;
};

export const PhoneNumberFormat = React.forwardRef<HTMLInputElement, PhoneNumberFormatProps>(
  function PhoneNumberFormat(props, ref) {
    const { onChange, ...other } = props;

    return (
      <PatternFormat
        {...other}
        getInputRef={ref}
        format="###-###-####"
        mask="_"
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value, // This will be the unformatted digits (e.g., "9999999999")
            },
          });
        }}
        valueIsNumericString={true}
      />
    );
  },
);
